import type {
    ArgumentsSchema,
    AvailableFieldBlockInfo,
    AvailableFilterBlockInfo,
    DataSourceAbstract,
    Field,
    FilterableProtocol,
    FilterBlockAbstract,
    FilterFormType,
    FilterMode,
    IndependentAction,
    PageVariableSchema,
    StateSchema,
    TypeInstanceMap,
    ViewField,
    ViewType
} from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import type { FlowNode, Workflow } from '../../types'
import { FilterContent } from './FilterContent'

interface ViewFieldFilterConfigureProps {
    primaryField?: string
    dataSource?: DataSourceAbstract
    availableFieldBlocksInfo?: AvailableFieldBlockInfo[]
    availableFilterBlocksInfo?: AvailableFilterBlockInfo[]
    dataSourceList: DataSourceAbstract[]
    workflowList?: Workflow[]
    pageVariables?: PageVariableSchema[]
    pagePathParameter?: ArgumentsSchema[]
    pageQueryParameter?: ArgumentsSchema[]
    pageStateParameter?: StateSchema[]
    upstreamNodes?: FlowNode[]
    allUpstreamNodes?: FlowNode[]
    allParentActions?: IndependentAction[]
    formDsId?: string
    columns: ViewField[]
    filter?: FilterableProtocol['filter']
    noSettingInnerType?: Set<TypeInstanceMap>
    fieldMode?: FilterMode
    paramsMode?: FilterMode
    enableCurrentUser?: boolean
    viewDsId?: string
    viewType?: ViewType
    extraViewFields?: Field[]
    paramsDataSource?: DataSourceAbstract
    isUseImage?: boolean
    maxHeight?: number
    filterBlocks?: FilterBlockAbstract[]
    enableFilterVariable?: boolean
    disabled?: boolean
    onFilter?: (val: FilterFormType) => void
    onMouseEnter?: (blockId: string) => void
    onMouseLeave?: () => void
}

const PropertySettingWrapper = styled.div<{ maxHeight?: number }>`
    padding: 8px 0;
    font-size: 14px;
    width: auto;
    overflow-y: auto;
    max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : 'auto')};
`

export const ViewFieldFilterConfigure: React.FC<ViewFieldFilterConfigureProps> = ({
    primaryField,
    dataSource,
    availableFieldBlocksInfo,
    availableFilterBlocksInfo,
    dataSourceList,
    workflowList,
    pagePathParameter,
    pageQueryParameter,
    pageStateParameter,
    pageVariables,
    upstreamNodes,
    allUpstreamNodes,
    allParentActions,
    columns,
    filter,
    noSettingInnerType,
    formDsId,
    fieldMode,
    paramsMode,
    enableCurrentUser,
    viewDsId,
    viewType,
    extraViewFields,
    paramsDataSource,
    isUseImage,
    maxHeight,
    filterBlocks,
    enableFilterVariable,
    disabled,
    onFilter,
    onMouseEnter,
    onMouseLeave
}) => {
    return (
        <PropertySettingWrapper maxHeight={maxHeight}>
            <FilterContent
                filter={filter}
                dataSource={dataSource}
                availableFieldBlocksInfo={availableFieldBlocksInfo}
                availableFilterBlocksInfo={availableFilterBlocksInfo}
                dataSourceList={dataSourceList}
                workflowList={workflowList}
                pagePathParameter={pagePathParameter}
                pageQueryParameter={pageQueryParameter}
                pageStateParameter={pageStateParameter}
                pageVariables={pageVariables}
                upstreamNodes={upstreamNodes}
                allUpstreamNodes={allUpstreamNodes}
                allParentActions={allParentActions}
                columns={columns}
                primaryField={primaryField}
                noSettingInnerType={noSettingInnerType}
                fieldMode={fieldMode}
                paramsMode={paramsMode}
                enableCurrentUser={enableCurrentUser}
                formDsId={formDsId}
                viewDsId={viewDsId}
                viewType={viewType}
                extraViewFields={extraViewFields}
                paramsDataSource={paramsDataSource}
                isUseImage={isUseImage}
                filterBlocks={filterBlocks}
                enableFilterVariable={enableFilterVariable}
                disabled={disabled}
                onFilter={onFilter}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            />
        </PropertySettingWrapper>
    )
}
